/**
 * Sign-in (S01) — phone OTP entry.
 *
 * @see prototype/index.html — V1.1 Studio Slate baseline
 * @see 08-system-decisions.md §1 — phone is the credential
 */
import { createFileRoute } from "@tanstack/react-router";
import {
  OnboardingShell,
  OnboardingHeader,
  Hero,
  HeroNote,
  BrandFor,
} from "../../../features/onboarding/components/index.ts";
import { SignInForm } from "../../../features/onboarding/components/sign-in-form.tsx";

export const Route = createFileRoute("/(auth)/sign-in/")({
  component: SignIn,
});

function SignIn() {
  return (
    <OnboardingShell
      header={<OnboardingHeader />}
      brand={<BrandFor step="signIn" />}
      footer="Secure phone verification · 14-day free trial starts after workspace creation"
    >
      <Hero
        kicker="Sign in or create your workspace"
        title="Start with your phone. Set up the business in minutes."
        description="Returning founders and new companies use the same secure entry. Verify the phone first, then either open the workspace or create it with company details and a 14-day trial."
      >
        <HeroNote>No password to create, reset, or remember.</HeroNote>
      </Hero>
      <SignInForm />
    </OnboardingShell>
  );
}
